import type { ReactNode } from 'react';

/**
 * Nothing here, and what to do about it.
 *
 * An empty screen without a next step is a dead end; this one always carries the reason
 * (`hint`) and, when there is something the person can do, the button that does it.
 */
export function EmptyState({
  title,
  hint,
  icon,
  action,
}: {
  title: string;
  hint?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="border-line bg-card flex flex-col items-center gap-2 rounded-lg border border-dashed px-6 py-12 text-center">
      {icon ? (
        <span className="bg-paper-2 text-ink-3 mb-1 inline-flex size-12 items-center justify-center rounded-full">
          {icon}
        </span>
      ) : null}
      <p className="text-ink font-display text-lg font-semibold">{title}</p>
      {hint ? <p className="text-ink-3 max-w-md text-[14.5px] leading-relaxed">{hint}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
